export enum OfflineSendStrategy {
	SendOnBuyPower,
	SendIfMoneyIsEnough,
	SendOnInputMoneyAmount
}

export enum OfflineOrderState {
	Offline,
	IsSent,
	Error
}

export interface OfflineIpoCreateRequest {
	symbolIsin: string;
	symbolName: string;
	price?: number;
	quantity?: number;
	offlineSendStrategy: OfflineSendStrategy;
	fullName: string;
	mobile: string;
}

export interface OfflineIpoUpdateRequest {
	orderId: string;
	symbolIsin: string;
	symbolName: string;
	price?: number;
	quantity?: number;
	offlineSendStrategy: OfflineSendStrategy;
	createDateTime: string;
}

export interface OfflineIpoOrder {
	id: string;
	symbolIsin: string;
	customerIsin: string;
	price: number;
	quantity: number;
	inputBudget: number;
	userIp: string;
	orderFrom: number;
	state: OfflineOrderState;
	errorType: number;
	sendStrategy: number;
	offlineSendStrategy: number;
	createDateTime: string;
}

export enum OfflineIpoPriceTextStatus {
	MaxMoneyNeeded,
	WithDescription,
	Unknown
}
